import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainContent from '../../../components/mainContent/MainContent';
import toast, { Toaster } from 'react-hot-toast';

import NotificacionesDataGrid from './NotificacionesDataGrid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import 'moment/locale/es';
import { DateInput } from '../../../components/dateInput/DateInput';
import { CustomButton } from '../../../components/customButton/CustomButton';

export default function ConsultaNotificaciones() {

  const navigate = useNavigate();
  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  const [showDataGrid, setShowDataGrid] = useState(false);
  const [listadoNotificaciones, setListadoNotificaciones] = useState([]);

  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const initFechaDesde = () => {
    let today = new Date();
    const fechaDesde = moment(today.setMonth(today.getMonth() - 1)).format("yyyy-MM-DD");
    return fechaDesde;
  };

  const initFechaHasta = () => {
    let today = new Date();
    const fechaHasta = moment(today).format("yyyy-MM-DD");
    return fechaHasta;
  };

  const [filtro, setFiltro] = useState({
    fechaDesde: initFechaDesde(),
    fechaHasta: initFechaHasta()
  });

  const isFormValid = () => {
    if (filtro.fechaDesde === null) {
      toast.error('Debe ingresar el campo Fecha Desde.');
      return false;
    }
    if (filtro.fechaHasta === null) {
      toast.error('Debe ingresar el campo Fecha Hasta.');
      return false;
    }
    return true;
  };

  const handleClickSearch = () => {
    if (isFormValid()) {
      search();
    }
  };

  const handleCloseDlgError = () => {
    navigate("/menu");
  };

  const handleChangeFechaDesde = (value) => {
    setFiltro((prevState) => {
      return { ...prevState, fechaDesde: value };
    });
  };

  const handleChangeFechaHasta = (value) => {
    setFiltro((prevState) => {
      return { ...prevState, fechaHasta: value };
    });
  };

  const QAllNotificaciones = gql`
    query QAllNotificaciones($idUsuario: Long!, $fechaDesde: String!, $fechaHasta: String!){
      allNotificaciones (filtros: {
        idUsuario: $idUsuario,
        fechaDesde: $fechaDesde,
        fechaHasta: $fechaHasta
      })
      {
        success,
        error,
        valorEsperado {
          idNotificacion,
          titulo,
          descripcion,
          fechaAlta,
          comentario,
          estado,
          link
        }            
      }
    }
  `;

  const [getAllNotificaciones, { loading, error, data: dataNotificaciones }] = useLazyQuery(QAllNotificaciones, {
    fetchPolicy: 'no-cache'
  });

  // Carga inicial
  useEffect(() => {
    getAllNotificaciones({
      variables: {
        idUsuario: idUsuario,
        fechaDesde: filtro.fechaDesde,
        fechaHasta: filtro.fechaHasta
      }
    });
  }, []);

  // Manejar respuesta
  useEffect(() => {
    if (!dataNotificaciones) return;

    console.log('Data recibida:', dataNotificaciones);

    if (dataNotificaciones.allNotificaciones.success) {
      setListadoNotificaciones(dataNotificaciones.allNotificaciones.valorEsperado);
      setShowDataGrid(true);
    } else {
      toast.error(dataNotificaciones.allNotificaciones.error || 'Error al cargar');
    }
  }, [dataNotificaciones]);

  // Manejar error
  useEffect(() => {
    if (!error) return;
    console.error('Error:', error);
    toast.error('Error al cargar notificaciones');
  }, [error]);

  const search = () => {
    const fechaDesde = moment(filtro.fechaDesde).format("yyyy-MM-DD");
    const fechaHasta = moment(filtro.fechaHasta).format("yyyy-MM-DD");

    // Ocultar grilla mientras carga
    setShowDataGrid(false);

    getAllNotificaciones({
      variables: {
        idUsuario: idUsuario,
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta
      }
    });
  };

  return (
    <MainContent
      component={
        <>
          <Accordion style={{ marginBottom: '10px' }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography style={{ fontWeight: 'bold', color: 'black', width: '100%', fontStyle: 'italic' }}>
                <span>Filtros</span>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Divider style={{ position: 'relative', top: '-15px' }} />
              <div style={{ display: 'inline-flex' }}>
                <div>
                  <DateInput
                    label="Fecha Desde"
                    value={filtro.fechaDesde}
                    onChange={handleChangeFechaDesde}
                  />
                </div>
                <div style={{ marginLeft: '20px' }}>
                  <DateInput
                    label="Fecha Hasta"
                    value={filtro.fechaHasta}
                    onChange={handleChangeFechaHasta}
                  />
                </div>
                <CustomButton
                  variant="contained"
                  size="small"
                  onClick={handleClickSearch}
                  loading={loading}
                  style={{ marginLeft: '20px' }}
                >
                  Buscar
                </CustomButton>
              </div>
            </AccordionDetails>
          </Accordion>

          {showDataGrid && <NotificacionesDataGrid rows={listadoNotificaciones} />}
        </>
      }
      titulo='Notificaciones'
    />
  );
}